import customAxios from "./axios";
import {
    WAREHOUSE_V1
} from "../constants/api";

export function getWarehouses(params) {
    return customAxios.get(WAREHOUSE_V1, {params});
}